/**
 * App
 */

import $ from 'jquery';
import AOS from '../../node_modules/aos/dist/aos';
import navbar from 'Components/navbar';

import 'Components/accordion.js';
import 'Components/fixed-header.js';
import 'Components/anchor.js';

document.addEventListener('DOMContentLoaded', function() {
    window.$ = $;

    AOS.init({
        offset: -210
    });

    navbar();

    if( typeof console === 'object' ) {
        const flame = String.fromCodePoint(0x1F525);
        const heart = String.fromCodePoint(0x1F49C);

        console.log('%c%s',
        'color: white; background: black; font-size: 18px;',
        '\n' +
        ' Made with ' + heart +' by Empowers Studio ' + flame + '\n' +
        ' Designed by –@Alexhehe94 \n' +
        ' Developed by -@whoiskamil \n' +
        ' Visit us => https://twitter.com/EmpowersStudio ');
    }
});